import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotificationSettings } from "../models/user.models";

export interface User {
  id: string;
  fullName: string;
  email: string;
  isClient: boolean;
  phoneNumber: string[];
  notificationsettings: NotificationSettings;
  notifications: Notification;
  role?: string;
  filledInitialForm?: boolean;
  createdAt?: number;
}

export interface UserState {
  loggedInUser: User | null;
}

const reducers = {
  setUser: (state: UserState, action: PayloadAction<User | null>) => {
    const payload = action.payload;
    if (payload) {
      const { fullName, email, id, isClient, phoneNumber, notificationsettings, notifications, role } = payload;

      const user = {
        fullName,
        email,
        id,
        isClient,
        phoneNumber,
        notificationsettings,
        notifications,
        role,
      };

      state.loggedInUser = user;
    } else {
      state.loggedInUser = action.payload;
    }
  },
};

const initialState: UserState = {
  loggedInUser: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers,
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
